import type { UserWithRole } from "~/types";

export const DEV_AUTH_ENABLED = import.meta.env.VITE_DEV_AUTH_BYPASS === "true";
export const DEV_AUTH_ROLE = (import.meta.env.VITE_DEV_AUTH_ROLE ||
  "landlord") as "landlord" | "tenant";

export const createMockUser = (role: "landlord" | "tenant"): UserWithRole => ({
  id: "dev-user-001",
  email: "dev@localhost",
  firstName: "Dev",
  lastName: "User",
  internalRole: role,
  role: role,
  verified: true,
  personalizations: {
    tableStyle: "grid",
  },
  organisation: {
    id: "org-dev-001",
    organizationName: "Dev Organization",
    owner: "Dev User",
    updatedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
  },
});

export const getMockSessionData = () => ({
  user: createMockUser(DEV_AUTH_ROLE),
  exp: Math.floor(Date.now() / 1000) + 3600, // 1 hour from now
  isAuthenticated: true,
  isLoading: false,
  isInitialLoad: false,
  isRefreshing: false,
});
